import { Box, styled } from '@mui/material';

export const StyledBox = styled(Box)(({ theme }) => ({
  '& .HIWitem': {
    height: '100%',
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.grey[100]}`,
    borderRadius: '5px',
    textAlign: 'center',
    padding: theme.spacing(3, 2),
    flexGrow: '1',
    [theme.breakpoints.down('lg')]: {
      padding: theme.typography.pxToRem(16),
    },
  },
  '& .HIWdesc': {
    color: theme.palette.secondary.light,
  },
  '&.HIWSDark': {
    '& .HIWMainTitle': {
      display: 'none',
    },
    '& .HIWitem': {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.grey[500],
      border: 0,
      '& .HIWTitle': {},
      '& .HIWdesc': {
        color: theme.palette.grey[100],
      },
    },
  },
}));
